/**
 * Check usr can view pulse ox widget or not
 */
import Backbone from 'backbone';

var UserPulseOxEnable = Backbone.Model.extend({
    capableName: 'pulseOxCapable',

    url: function() {
        return '/userprofile-service/userprofile/capableEnable/' + this.capableName;
    },
    backend: 'gcapi',

    initialize: function(models, args) {}
});

export default UserPulseOxEnable;
